import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import portService from '~/services/cruises/PortService';

import { portPOIQueryKeys } from './portPOIQueryKeys';

interface DeletePortPOIParams {
  portId: string;
  poiId: string;
}

export function useDeletePortPOI() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: ({ portId, poiId }: DeletePortPOIParams) => portService.deletePortPOI(portId, poiId),
    onSuccess: (_result, variables) => {
      queryClient.invalidateQueries({ queryKey: portPOIQueryKeys.detail(variables.portId) });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to delete point of interest: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
